import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BedroomParentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bedroom_parent"}/>
}
